module.exports = __webpack_public_path__ + "5a7b968bf6ce95f984e5b13bca282f85.svg";